// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"b7a81fa6","161":"813d5a21","241":"90e20b2a","399":"c596fdb1","438":"7c6744bd","453":"096c7828","580":"2098e0d2","635":"7ed7b1fb","795":"e02877e4","805":"e96d2111"}[chunkId] + ".chunk.js";
};